/**
 * Schémas Zod du référentiel des rôles et permissions.
 * Référence : document 06 § 6.1 (contrats d'entrée).
 */
import { z } from 'zod';
import { includeSchema, paginationQuerySchema, searchSchema } from './common.schema.js';
/** Code technique d'un rôle personnalisé : minuscules, chiffres et « _ ». */
export const roleCodeSchema = z
    .string()
    .min(2)
    .max(64)
    .regex(/^[a-z][a-z0-9_]*$/, {
    message: 'Code de rôle invalide (minuscules, chiffres et « _ » uniquement).',
});
/** Corps de `POST /roles`. */
export const createRoleSchema = z.object({
    code: roleCodeSchema,
    name: z.string().min(2).max(80),
    description: z.string().max(255).optional(),
    permissionCodes: z.array(z.string().min(3).max(64)).max(200).default([]),
});
/** Corps de `PATCH /roles/:id` : au moins un champ à modifier. */
export const updateRoleSchema = z
    .object({
    name: z.string().min(2).max(80).optional(),
    description: z.string().max(255).nullable().optional(),
    permissionCodes: z.array(z.string().min(3).max(64)).max(200).optional(),
})
    .refine((value) => Object.values(value).some((field) => field !== undefined), {
    message: 'Aucun champ à mettre à jour.',
});
/** Paramètres de `GET /roles`. */
export const roleListQuerySchema = paginationQuerySchema.extend({
    search: searchSchema,
    include: includeSchema,
});
/**
 * Paramètres de `GET /permissions`.
 * `filter[module]` et `filter[action]` affinent le référentiel (document 06 § 2.6).
 */
export const permissionListQuerySchema = paginationQuerySchema.extend({
    filter: z
        .object({
        module: z.string().min(1).max(40).optional(),
        action: z.string().min(1).max(32).optional(),
    })
        .optional(),
});
//# sourceMappingURL=rbac.schema.js.map